import { initializePostHogIfConsented } from './utils/posthogClient'
import { isSensitiveAnalyticsUrl } from './utils/analyticsUrl'
import { promoteLegacyUnsubscribeQueryToFragment } from './utils/unsubscribeUrl'

// This import path contains no eager `posthog-js` import. The SDK chunk is
// fetched asynchronously while sensitive unsubscribe URLs remain excluded.
// Promote already-issued legacy links before analytics code can
// initialize. The sensitive-route gate remains necessary for fragment links
// and for a persisted provider callback during client navigation.
promoteLegacyUnsubscribeQueryToFragment(window)

// Unsubscribe URLs carry a bearer capability. Do not even load the SDK on a
// sensitive initial route; the controller repeats this check for later calls.
if (!isSensitiveAnalyticsUrl(window.location.href)) {
  void initializePostHogIfConsented()
}
